/**
 * Veluna Quiz Diagnostics - DISABLED IN PRODUCTION
 *
 * The previous build of this file monkey-patched
 * EventTarget.prototype.addEventListener globally. When third-party
 * scripts (e.g. Shopify perf-kit) called addEventListener with a
 * non-Element `this` (or a detached call), the patch threw
 * "Cannot read properties of undefined (reading 'matches')",
 * which broke quiz step transitions and other page interactions.
 *
 * This file is now a no-op shim. To re-enable diagnostics,
 * gate behind ?quiz-diag=1 and never patch global prototypes.
 */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  window.quizDiagnostics = window.quizDiagnostics || {
    enabled: false,
    log: function () {},
    captureRadioState: function () { return null; },
    generateReport: function () { return { disabled: true }; }
  };
})();
